import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
const socialLinks = [
    { icon: FaLinkedinIn, link: "https://www.linkedin.com/company/growx-samrattechitsolutions/?viewAsMember=true" },
    { icon: FaInstagram, link: "https://www.instagram.com/growx_samrattechitsolutions/" },
    { icon: FaFacebookF, link: "https://www.facebook.com/growx.samrattechitsolutions/" },
    { icon: FaXTwitter, link: "https://x.com/growx_samrattec",}
  ];

  export default socialLinks;